import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getPollActvityResponses = async (activityId) => {
    const { data } = await vlqrApi.get(`/FocusGroupPollActivities/${activityId}/pollResponses`)
        .catch((error) => {
            handleError(error);
        });
    return data?.filter(x => !x.deletedOn);
};

const getPollActivityResponsesForCrossSessionActivity = async (crossSessionActivityId) => {
    const { data } = await vlqrApi.get(`/FocusGroupPollActivities/crossSession/${crossSessionActivityId}/pollResponses`)
        .catch((error) => {
            handleError(error);
        });

    // Exclude deleted sentiment/comments
    return data?.filter(x => !x.deletedOn);
};

const usePollAnswersForActivity = ({ activityId, crossSessionId }) => {
    const queryKey = [crossSessionId
        ? 'pollResponsesForCrossSessionActivity'
        : 'pollResponsesForActivity'];
    const queryKeyValue = crossSessionId ?? activityId;

    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: [queryKey, queryKeyValue],

        queryFn: () => crossSessionId
            ? getPollActivityResponsesForCrossSessionActivity(crossSessionId)
            : getPollActvityResponses(activityId)
    });

    return { data, refetch, isLoading, isError };
};

export default usePollAnswersForActivity;
